//Обработка запросов к корзине
(function () {
    //Добавление товара в корзину
    document.addEventListener('submit', event => {
        const cartForm = event.target.closest('form.cart');
        if (!cartForm) return;

        event.preventDefault();

        const formData = new FormData(cartForm);

        const ajaxUrl = wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart');

        fetch(ajaxUrl, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.error && data.product_url) {
                    window.location = data.product_url;
                    return;
                }

                jQuery(document.body).trigger('added_to_cart', [data.fragments, data.cart_hash]);
            });
    });

    // Кнопка "В корзину" в закреплённой панели товара
    document.addEventListener('click', event => {
        const button = event.target.closest('.product-scroll-line__cart-button');
        if (!button) return;

        event.preventDefault();

        const cartForm = document.querySelector('form.cart');
        if (!cartForm) return;

        if (cartForm.requestSubmit) {
            cartForm.requestSubmit();
        } else {
            cartForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
    });

    // Обновление цены в закреплённой панели при смене вариации
    jQuery(function ($) {
        const $form = $('form.cart');
        const $scrollPrice = $('.product-scroll-line__price');

        if (!$form.length || !$scrollPrice.length) return;

        $form.on('found_variation show_variation', function (event, variation) {
            if (!variation || !variation.price_html) return;

            $scrollPrice.html(variation.price_html);
        });
    });

    //Изменить кол-во товара в мини корзине
    const updateCartItemQuantity = debounce(cartItemEl => {
        const requestData = new FormData();
        requestData.append('quantity', cartItemEl.querySelector('input.qty-input').value);
        requestData.append('cart_item_key', cartItemEl.querySelector('input.cart-item-key').value);

        jQuery('.mini-cart-list').block({
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6
            }
        });

        fetch(ajaxurl + '?action=update_cart_item_quantity', {
            method: 'POST',
            body: requestData
        }).then((response) => response.json()).then((data) => {
            Object.keys(data.fragments).forEach(key => {
                document.querySelectorAll(key).forEach(element => {
                    element.outerHTML = data.fragments[key];
                });
            });
            jQuery(document.body).trigger('wc_fragments_refreshed');

            if (data.fragments['metric']) {
                if (data.fragments['metric']['action'] === 'add') {
                    jQuery(document.body).trigger('added_to_cart', data.fragments);
                } else if (data.fragments['metric']['action'] === 'remove') {
                    jQuery(document.body).trigger('removed_from_cart', data.fragments);
                }
            }
        });
    }, 1000);
    document.body.addEventListener('change', event => {
        if (event.target.closest('.mini-cart-sidebar .qty-input')) {
            updateCartItemQuantity(event.target.closest('.mini-cart-sidebar .item'));
        }
    });
})();